import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0d48a1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ms-5 mt-2 pb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Distribution of partnerships", -1))
const _hoisted_3 = { class: "row my-3" }
const _hoisted_4 = { class: "col-4 flex-grow-3" }
const _hoisted_5 = {
  class: "progress mx-auto first-progress",
  "data-value": "35"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_8 = { class: "progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center" }
const _hoisted_9 = { class: "h2 font-weight-bold mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 ml-2 mx-2 my-auto text-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark partner-text" }, "Manufacturing"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-dark partner-text" }, "Contract manufacturing")
], -1))
const _hoisted_11 = { class: "row my-3" }
const _hoisted_12 = { class: "col-4 flex-grow-3" }
const _hoisted_13 = {
  class: "progress mx-auto second-progress",
  "data-value": "25"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_16 = { class: "progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center" }
const _hoisted_17 = { class: "h2 font-weight-bold mb-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 ml-2 mx-2 my-auto text-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark partner-text" }, "Financial"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-dark partner-text" }, " Donors, grants, VC funded, angel investors etc ")
], -1))
const _hoisted_19 = { class: "row my-3" }
const _hoisted_20 = { class: "col-4 flex-grow-3" }
const _hoisted_21 = {
  class: "progress mx-auto third-progress",
  "data-value": "20"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "progress-bar" })
], -1))
const _hoisted_24 = { class: "progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center" }
const _hoisted_25 = { class: "h2 font-weight-bold mb-0" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 ml-2 mx-2 my-auto text-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark partner-text" }, "Technology"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-dark partner-text" }, " Technology transfer and licensing ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.distributionDetail && _ctx.distributionDetail.implementation), 1)
            ])
          ])
        ]),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.distributionDetail && _ctx.distributionDetail.financial), 1)
            ])
          ])
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.distributionDetail && _ctx.distributionDetail.technology), 1)
            ])
          ])
        ]),
        _hoisted_26
      ])
    ])
  ]))
}